<template>
<div class="banner">
    <slot  name="banner-img"></slot>
	<div class="bigSlogan">
		<slot name="banner-bigSlogan"></slot>
	</div>
	<div class="slogan">
		<slot name="banner-slogan"></slot>
	</div>
    <slot  class="bannerVideo" name="banner-video"></slot>
    <slot  name="banner-button"></slot>
</div>
</template>

<script>
export default {
    name: 'banner',
    methods: {
         goUrl(path) {
            if (path !== this.$route.path && path.search('http') == -1) {
                this.$router.push(path)
            } else if (path.search('http') != -1) {
                window.open(path)
            }
        },
    },
    
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
.banner {
    @include middle;
    width: 1920px;
    height: 480px;
    overflow: hidden;
    video{
        position: relative;
        left: 50%;
        transform: translateX(-50%)
    }

    button {
        @include middle;
        position: absolute;
        top: 312px; 
        width: 160px;
        height: 48px;
        cursor: pointer;
        border: transparent;
        outline: transparent;
        background: transparent;

    }
	.bigSlogan{
		@include middle;
		position: absolute;
		font-size: 48px;
		color: white;
		top: 140px;
	}
	.slogan{
		@include middle;
		position: absolute;
		font-size: 24px;
		color: white;
		top: 240px;
	}

}
</style>
